import {AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { ApiService } from '../services/api/api.service'

export function EmailUniquenessValidator(apiService: ApiService, userId: number): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors> | null => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const value = control.value

       //validating email format prior on checking domain.
       const emailRegex = new RegExp('^[\\w+-.]+@([\\w-]+\\.)+[\\w-]{2,4}$')

       if(!emailRegex.test(value)){
           return  Promise.resolve({ email: true })
       }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      if (!value || value.indexOf('@') < 0 || control.status === 'INVALID') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return Promise.resolve(null)
      }

      return apiService.isEmailUnique(value, userId).then((isUnique) => {
        return !isUnique ? { emailInUse: true } : null
      })
    }
  }
